import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class TokenService {
  // localStorage no existe en el prerender (Node): ahí el token queda en null y no se persiste nada.
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private _access = signal<string | null>(this.isBrowser ? localStorage.getItem('access') : null);
  get access() { return this._access(); }
  set access(v: string | null) {
    this._access.set(v);
    if (!this.isBrowser) return;
    if (v) localStorage.setItem('access', v); else localStorage.removeItem('access');
  }
}
